import { useState } from 'react';
import { Button, Input, Card, Alert } from '@dreamtree-org/twreact-ui';
import { useAppApi } from '@/lib/api';
import { errorText } from '@/lib/format';

export default function PlatformLogin({ onSignedIn }) {
  const { fetchApi, loading } = useAppApi();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    try {
      const res = await fetchApi('platformLogin', { email, password });
      onSignedIn(res.data);
    } catch (ex) {
      setErr(errorText(ex));
    }
  };

  return (
    <div className="min-h-dvh flex items-center justify-center p-4 pt-safe pb-safe bg-[var(--app-bg)]">
      <Card className="w-full max-w-sm p-6 space-y-4">
        <div className="text-center space-y-1">
          <h1 className="text-xl font-bold text-primary-600">MerchantPro Cloud</h1>
          <p className="text-sm opacity-70">Platform administration</p>
        </div>
        {err ? <Alert variant="error" title="Sign-in failed">{err}</Alert> : null}
        <form onSubmit={submit} className="space-y-4">
          <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <Input label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <Button type="submit" fullWidth loading={loading}>Sign in</Button>
        </form>
      </Card>
    </div>
  );
}
